import React from 'react'; // eslint-disable-line

import t, { CSSStyle } from '../../theme/newstyles';

/** @jsxImportSource @emotion/react */

export function DialogContent(props: { children?: React.ReactNode; contentStyle?: CSSStyle }) {
  return <div css={[t.px_5, t.pb_4, t.sm([t.pb_5]), t.md([t.px_7, t.pb_6]), props.contentStyle]}>{props.children}</div>;
}
